export const PAY_MEAN_CODE = {
  CARD: '11', //신용카드
  REAL_TIME_BANK: '12', //실시간계좌이체
  V_BANK: '13', //가상계좌
  SAMSUNG_WALLET: '14',
  HPP: '16', //핸드폰 소액결제
  HP: '19', // 핸드폰 결제
};
